import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/Chicago.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose TekRevol for Software Development in Chicago?</h2>
            <p>
              Choose TekRevol's software development expertise in Chicago, where
              innovation converges with local excellence to deliver bespoke
              solutions for your business prosperity. Our impressive track
              record speaks for itself, with a history of delivering exceptional
              software apps that have earned industry accolades. Being a trusted
              software development company in Chicago, we possess an in-depth
              understanding of the local market's nuances, providing your app
              with a competitive advantage. Our team specializes in crafting
              customized software apps that align precisely with your unique
              business objectives, ensuring a seamless fit. We thrive on
              innovation, introducing inventive concepts to set your software
              app apart and propel its success.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
